import styled, { css } from 'styled-components';

export const Container = styled.span<{
  $overdue?: boolean;
  $lastWeek?: boolean;
  $isCompleted?: boolean;
}>`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(0.75)};

  padding: ${({ theme }) => `${theme.spacing(0.25)} ${theme.spacing(2)}`};

  overflow: hidden;
  border-radius: ${({ theme }) => theme.spacing(3)};
  transition: color 200ms;

  text-overflow: ellipsis;
  white-space: nowrap;

  border: 1px solid ${({ theme }) => theme.palette.grey[300]};
  color: ${({ theme }) => theme.palette.text.secondary};

  ${({ $lastWeek, theme }) =>
    $lastWeek &&
    css`
      border: 1px solid ${theme.palette.warning.light};
      color: ${theme.palette.warning.main};
    `};

  ${({ $overdue, theme }) =>
    $overdue &&
    css`
      border: 1px solid ${theme.palette.error.light};
      color: ${theme.palette.error.main};
    `};

  ${({ $isCompleted, theme }) =>
    $isCompleted &&
    css`
      border: 1px solid ${theme.palette.grey[300]};
      color: ${theme.palette.text.secondary};
    `};
`;
